import React from "react";
import "./ConnectAssistEarn.css";

const ConnectAssistEarn = () => {
  return (
    <div className="ConnectAssistEarn-parent-div">
      <div>
        <h3>Connect</h3>
      </div>
      <div>
        <h3>Assist</h3>
      </div>
      <div>
        <h3>Earn</h3>
      </div>
    </div>
  );
};

export default ConnectAssistEarn;
